export const selectedCoupon = (state) => {
  if (!state.coupons || !state.coupons.length) return
  const coupons = state.coupons.filter((coupon) => {
    return state.discount_recommend === coupon.id
  })
  return coupons[0]
}



// WEBPACK FOOTER //
// ./src/store/order/getters.js